
import { Component, Mixins, Emit } from 'vue-property-decorator';
import Pages from '@/mixins/Pages';
@Component
export default class PagesJa extends Mixins(Pages) {

}
